import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ALLOWED_ORIGINS = [
  "https://insight-chile.cl",
  "https://35.206.74.26",
  "https://fe-sofia-ia-637186488822.us-east1.run.app"
];

// Rutas que no se validan
const EXCLUDED_PATHS = [
  "/carga",
  "/cargaPagina",
  "/grafico-filtro",
  "/actualizar-grafico-filtro",
  "/crear-grafico-dinamic"
];

const IframeGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {

    // console.log("EXCLUDED_PATHS:",EXCLUDED_PATHS);
    // // // Si la ruta está excluida, permitir siempre
    // console.log("PATHNAME:", location.pathname);
    if (EXCLUDED_PATHS.includes(location.pathname)) {
        // console.log("Ruta excluida, acceso permitido:", location.pathname);
        setAllowed(true);
        return;
    } else {
        // console.log("Ruta no excluida, validando iframe:", location.pathname);
        let inIframe = false;

        try {
            inIframe = window.self !== window.top;
        } catch {
            inIframe = true; // cross-origin iframe
        }

        const referrer = document.referrer || "";

        const allowedOrigin = ALLOWED_ORIGINS.some(origin =>
            referrer.startsWith(origin)
        );

        if (inIframe && allowedOrigin) {
            setAllowed(true);
        } else {
            setAllowed(false);
        }
    }
  }, []);

  if (allowed === null) return null;

  if (!allowed) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "sans-serif"
        }}
      >
        <h2>Acceso no permitido</h2>
      </div>
    );
  }

  return <>{children}</>;
};

export default IframeGuard;
